import ConditionalComponent from './conditional-component.js';

export const ConditionalControl = wp.customize.KadenceControl.extend( {
	renderContent: function renderContent() {
		let control = this;
		ReactDOM.render( <ConditionalComponent control={ control } />, control.container[0] );
	}
} );
